import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { BASE_URL_USER } from "../../Redux/App/action";
import { IoMailSharp } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { useToast } from "@chakra-ui/react";
import {
  BiLogoTwitter,
  BiLogoInstagramAlt,
  BiLogoLinkedin,
  BiLogoFacebook,
  BiSolidPhoneCall,
} from "react-icons/bi";

const userFeedback = {
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  inquiry: "",
  message: "",
};

const ContactUs = () => {
  const accessToken = localStorage.getItem("token");
  const toast = useToast();

  const contactSchema = Yup.object({
    firstName: Yup.string().required("required").min(2).max(30),
    lastName: Yup.string().required("required").min(2).max(30),
    email: Yup.string()
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Must be valid email")
      .required("required"),
    mobile: Yup.string()
      .matches(/^\d{0,10}$/)
      .required("required")
      .max(10),
    inquiry: Yup.string().required("required"),
    message: Yup.string().required("required"),
  });

  const sendUserFeedback = (formData) => {
    axios
      .post(`${BASE_URL_USER}/public-api/v1/contact-us`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          console.log(response);
          toast({
            title: "Thanks for reaching us",
            status: "success",
            duration: 2000,
            position: "top",
            isClosable: true,
          });
        }
      })
      .catch((error) => {});
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    isSubmitting,
  } = useFormik({
    initialValues: userFeedback,
    validationSchema: contactSchema,
    enableReinitialize: true,
    async onSubmit(values) {
      // handle form submit
      const valueObj = {
        inqueryType: values?.inquiry,
        name: `${values?.firstName} ${values?.lastName}`,
        email: values?.email,
        mobileNo: values?.mobile,
        message: values?.message,
      };
      sendUserFeedback(valueObj);
    },
  });

  return (
    <div className="bg-[#fbfbfb] flex flex-col justify-center items-center sm:mt-24">
      <div>
        <h1 className="font-bold text-2xl md:text-3xl my-2">Contact Us</h1>
        <div className="text-gray-700 md:flex md:gap-2">
          <p>Any question or remarks?</p>
          <p>Just write us a message!</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row md:gap-10 p-2 shadow-md mx-3 my-5 rounded-lg">
        <div className="bg-[#372449] text-white rounded-lg p-3 md:w-1/2">
          <div className="md:flex md:flex-col md:justify-between my-3 md:pl-3">
            <h2 className="font-semibold text-xl md:text-left md:text-2xl">
              Contact Information
            </h2>
            <div className="mt-5">
              <div className="flex flex-col justify-center items-center md:flex-row md:justify-start gap-5 my-5 md:my-10">
                <BiSolidPhoneCall size={25} />
                <p className="mt-3 md:mt-0">9625679829</p>
              </div>
              <div className="flex flex-col justify-center items-center md:flex-row md:justify-start gap-5 my-5 md:my-10">
                <IoMailSharp size={25} />
                <div className="mt-3">
                  <p>Support@wishfy.io</p>
                  <p>Sales@wishfy.club</p>
                </div>
              </div>
              <div className="flex flex-col justify-center items-center md:flex-row md:justify-start gap-5 my-5 md:my-10">
                <FaLocationDot size={25} />
                <div className="mt-3 md:mt-0">
                  <p>H-166, Suite 202, Noida Sector 63</p>
                </div>
              </div>
            </div>

            <div className="flex justify-center md:justify-start space-x-4 mt-20">
              <div className="flex justify-center items-center w-10 h-10 border-[1px] rounded-full hover:bg-[#1ec5f7]">
                <a
                  href="https://in.linkedin.com/company/wishfy-technologies"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  <BiLogoLinkedin color="white" size={22} />
                </a>
              </div>

              <div className="flex justify-center items-center w-10 h-10 border-[1px] rounded-full hover:bg-[#1ec5f7]">
                <a
                  href="https://x.com/wishfyofficial"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  <BiLogoTwitter color="white" size={22} />
                </a>
              </div>
              <div className="flex justify-center items-center w-10 h-10 border-[1px] rounded-full hover:bg-[#1ec5f7]">
                <a
                  href="https://www.instagram.com/wishfy.official/"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  <BiLogoInstagramAlt size={22} />
                </a>
              </div>
              <div className="flex justify-center items-center w-10 h-10 border-[1px] rounded-full hover:bg-[#1ec5f7]">
                <a
                  href="https://www.facebook.com/profile.php?id=61554507296223"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  <BiLogoFacebook color="white" size={22} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="my-5 px-3">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col text-left my-5">
              <label htmlFor="firstName" className="text-gray-700">
                First Name
              </label>
              <input
                id="firstName"
                type="text"
                value={values["firstName"] || ""}
                onChange={handleChange}
                error={errors["firstName"] || ""}
                className="outline-none bg-transparent border-b border-b-black"
              />
            </div>
            <div className="flex flex-col text-left my-5">
              <label htmlFor="lastName" className="text-gray-700">
                Last Name
              </label>
              <input
                id="lastName"
                type="text"
                value={values["lastName"] || ""}
                error={errors["lastName"] || ""}
                onChange={handleChange}
                className="outline-none bg-transparent border-b border-b-black"
              />
            </div>
            <div className="flex flex-col text-left my-5">
              <label htmlFor="email" className="text-gray-700">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={values["email"] || ""}
                error={errors["email"] || ""}
                onChange={handleChange}
                className="outline-none bg-transparent border-b border-b-black"
              />
            </div>
            <div className="flex flex-col text-left my-5">
              <label htmlFor="mobile" className="text-gray-700">
                Phone Number
              </label>
              <input
                id="mobile"
                type="number"
                value={values["mobile"] || ""}
                error={errors["mobile"] || ""}
                onChange={handleChange}
                className={`outline-none bg-transparent border-b border-b-black`}
              />
            </div>

            <div className="text-left">
              <h2 className="font-semibold  my-2">Select Subject</h2>
              <div className="flex flex-wrap justify-between items-center gap-3">
                <div>
                  <input
                    type="radio"
                    id="General"
                    name="inquiry"
                    value="GENERAL"
                    checked={values["inquiry"] === "GENERAL"}
                    onChange={handleChange}
                  />
                  <label htmlFor="General">General Inquiry</label>
                </div>
                <div>
                  <input
                    type="radio"
                    id="Business"
                    name="inquiry"
                    value="BUSINESS"
                    checked={values["inquiry"] === "BUSINESS"}
                    onChange={handleChange}
                  />
                  <label htmlFor="Business">Business Inquiry</label>
                </div>
                <div>
                  <input
                    type="radio"
                    id="Grievance"
                    name="inquiry"
                    value="GRIEVANCE"
                    checked={values["inquiry"] === "GRIEVANCE"}
                    onChange={handleChange}
                  />
                  <label htmlFor="Grievance">Grievance Inquiry</label>
                </div>
                <div>
                  <input
                    type="radio"
                    id="Affiliate"
                    name="inquiry"
                    value="AFFILIATE"
                    checked={values["inquiry"] === "AFFILIATE"}
                    onChange={handleChange}
                  />
                  <label htmlFor="Affiliate">Affiliate Inquiry</label>
                </div>
              </div>
            </div>

            <div className="flex flex-col text-left my-5">
              <label htmlFor="message">Message</label>
              <input
                id="message"
                type="text"
                value={values["message"] || ""}
                onChange={handleChange}
                placeholder="Write your message..."
                className="outline-none bg-transparent border-b border-b-black"
              />
            </div>

            <div className="flex justify-end items-end">
              <button
                type="submit"
                className="bg-[#372449] text-white w-full py-2 rounded-md my-3 md:w-40"
              >
                Send Message
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
